import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from 'emotion';

import { PrimaryColor } from '../styles/colors';

const SIZE = 32;
const LINE_SIZE = 3;

const px = pixels => `${Math.round(pixels)}px`;

const Container = styled.div`
  position: relative;

  width: ${SIZE}px;
  height: ${SIZE}px;

  cursor: pointer;
`;

const LineStyles = css`
  position: absolute;

  transition: all .25s;

  height: ${LINE_SIZE}px;

  background-color: ${PrimaryColor};
`;

const AStyles = css`
  width: ${px(SIZE * 0.7)};
  top: 7px;
  left: -2px;
  transform: rotate(45deg);
`;

const ACloseStyles = css`
  width: ${px(SIZE * 1.3125)};
  top: 13px;
  left: -5px;
  transform: rotate(225deg); // -135deg); // 225deg);
`;

const BStyles = css`
  width: ${px(SIZE * 0.7)};
  top: 7px;
  right: -2px;
  transform: rotate(-45deg);
`;

const BCloseStyles = css`
  width: ${px(SIZE * 1.3125)};
  top: 13px;
  right: -5px;
  transform: rotate(135deg); // -225deg);
`;

const Collapsor = ({ open, className, onClick }) => (
  <Container className={className} onClick={onClick}>
    <div className={`${LineStyles} ${AStyles} ${open ? ACloseStyles : ''}`} />
    <div className={`${LineStyles} ${BStyles} ${open ? BCloseStyles : ''}`} />
  </Container>
);

Collapsor.propTypes = {
  open: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Collapsor.defaultProps = {
  open: false,
  className: undefined,
  onClick: undefined,
};

export default Collapsor;



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/Collapsor.js